import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "./lib/api";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setError("session_id não encontrado.");
      return;
    }
    const session_id = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Falha na autenticação.";
        console.error("Auth callback failed:", msg);
        setError(msg);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen theme-dark flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <div className="font-display text-2xl mb-2 text-accent-orange">Erro de acesso</div>
            <div className="text-sm text-neutral-400 mb-6">{error}</div>
            <a href="/admin/login" className="text-accent-yellow underline text-sm">Tentar novamente</a>
          </>
        ) : (
          <>
            <Loader2 className="w-8 h-8 animate-spin text-accent-yellow mx-auto mb-4" />
            <div className="text-sm text-neutral-400">Autenticando…</div>
          </>
        )}
      </div>
    </div>
  );
}
